import { MeepCardService } from '../../services/meepCard.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { DependentService } from '../../services/dependent.service';
import { Component, OnInit } from '@angular/core';
import { DependentMeepServerModel } from '../../models/dependent.model';

@Component({
  selector: 'app-dependent-card',
  templateUrl: './dependent-card.component.html',
  styleUrls: ['./dependent-card.component.less']
})
export class DependentCardComponent implements OnInit {

  dependents: Array<DependentMeepServerModel> = new Array<DependentMeepServerModel>();

  constructor(private notificationService: NotificationService, private dependentService: DependentService,
    private meepCardService: MeepCardService) { }

  ngOnInit() {
    Promise.all([
      this.dependentService.getAllFromMeepServer(),
      this.dependentService.getAllFromMeepServerRotativo()
    ])
    .then((response: any) => {
        this.dependents = [];
        response[0].forEach(dependent => {
          dependent.EhNominal = true;
          dependent.LinkMaisInformacoes = `/general/dependentesSingle/${dependent.Tag}/nominal`;
          this.dependents.push(dependent);
        });
        response[1].forEach(dependent => {
          dependent.EhNominal = false;
          dependent.LinkMaisInformacoes = `/general/dependentesSingle/${dependent.HistoricoAssociacaoId}/rotativo`;
          this.dependents.push(dependent);
        });
    })
    .catch((err) => {
      this.notificationService.showErrorNotification(err.message);
    });
  }

  updateDependent(meepCard: DependentMeepServerModel) {
      this.meepCardService.updateDeactiveCard(
        {
          Tag: meepCard.Tag,
          Status: meepCard.Status.Id
        }, meepCard.EhNominal)
      .then(() => {
        return this.notificationService.showSuccessNotification('Cartão alterado com sucesso!');
      })
      .then(() => {
        const status = meepCard.Status.Id === 1 ? true : false;
        this.refreshDependentActive(meepCard, status);
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message).then(() => {
          const status = meepCard.Status.Id === 1 ? true : false;
          this.refreshDependentActive(meepCard, !status);
        });
      });


  }

  private refreshDependentActive(meepCard: DependentMeepServerModel, isActive: boolean) {
    this.dependents.forEach((elm) => {
      if (elm.Id === meepCard.Id) {
        elm.Status.Id = isActive ? 1 : 0;
      }
    });
  }

  setIsActive(event, dependent: DependentMeepServerModel) {
    if (!event.checked) {
      this.notificationService.showQuestionNotification('Você deseja desativar esse cartão?')
      .then((result) => {
        if (result.value) {
          dependent.Status.Id = 0;
          console.log(dependent.Status.Id);
          this.updateDependent(dependent);
        } else {
          this.refreshDependentActive(dependent, true);
        }
      });
    } else {
      dependent.Status.Id = 1;
      this.updateDependent(dependent);
    }
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/dependent-card/dependent-card.component.ts